module.exports = __webpack_public_path__ + "img/fully-automated.8d6cff6f.svg";